// extracted by mini-css-extract-plugin
export var box = "SmorgasbordNkiModule-module--box--q9n69";
export var circle = "SmorgasbordNkiModule-module--circle--jDY8y";
export var circleTitle = "SmorgasbordNkiModule-module--circleTitle--r4V6z";
export var title = "SmorgasbordNkiModule-module--title--1VXre";
export var wrapper = "SmorgasbordNkiModule-module--wrapper--YxQE4";